import { Col, Row, } from "antd";
import ListItems from "./Components/ListItems";
import { useGetAlarms } from "./ServerSideStates";
import PageTitle from "apps/Common/PageTitle";
import { Helmet } from "react-helmet-async";



const AlarmIndex = () => {


  const alarms = useGetAlarms();

  return (
    <>
      <Col xs={24} 
      className="!p-0"
      >
        <Helmet>
                      <title className="capitalize">{"Alarm Listesi"}</title>
                    </Helmet>
        <Row 
         gutter={[
          { xs: 10, md:10 , xl:10 }, 
          { xs:10 , md: 15, xl:20}   
        ]}
        className="">
          
          <Col span={24} className="!flex justify-center">
          <PageTitle
          title="Alarm Listesi"
          count={alarms?.data?.data?.length }
          />
            
          </Col>

          <Col xs={24} className="">
            <ListItems/>
          </Col>
        </Row>
      </Col>
      <></>
    </>
  );
};

export default AlarmIndex;
